import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, ArrowRight, Leaf } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative overflow-hidden pt-28 pb-16 md:pt-36 md:pb-24 px-5 md:px-8 noise">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 mb-6">
          <span className="inline-flex items-center gap-2 bg-white px-3 py-1.5 rounded-full crunch-shadow-sm text-xs font-bold uppercase tracking-wider">
            <span className="w-2 h-2 bg-[#E63946] rounded-full animate-pulse" /> Cooking in our kitchen
          </span>
        </div>

        <h1 className="font-display text-[14vw] md:text-[9vw] lg:text-[8rem] leading-[0.9] tracking-tight uppercase">
          Snacks that <br className="hidden md:block" />
          <span className="text-[#E63946]">don’t play</span> <span className="italic">boring.</span>
        </h1>

        <div className="grid md:grid-cols-2 gap-8 mt-10 items-end">
          <p className="text-lg md:text-xl max-w-lg font-brico">
            While we cook up our healthy snacks in the kitchen, <span className="font-bold underline decoration-[#E63946] decoration-4 underline-offset-4">play Sky Catch</span> and win a real TruCrunch hamper.
          </p>

          <div className="flex flex-wrap gap-3">
            <Link to="/play" data-testid="hero-play-cta" className="btn-chunky primary">
              <Gamepad2 size={18} /> Play 30s Game
            </Link>
            <Link to="/shop" className="btn-chunky outline">
              <Leaf size={18} /> Shop <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        {/* Decorative floating shapes */}
        <div className="absolute right-4 top-24 md:right-16 md:top-32 float hidden sm:block">
          <div className="w-24 h-24 md:w-40 md:h-40 rounded-full bg-[#FFD84D] crunch-shadow flex items-center justify-center rotate-12">
            <div className="font-display text-center text-[#1a1a1a] text-xs md:text-base leading-tight">
              TOP<br />PLAYERS<br />WIN
            </div>
          </div>
        </div>

        <div className="absolute left-1/2 bottom-6 wobble hidden lg:block">
          <div className="w-16 h-16 rounded-full bg-[#2A9D8F] crunch-shadow-sm" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
